import React from 'react'

export default function Links() {
    return (
        <div className='md:-mt-[10vw] relative z-30'>

            <div className=''>
                <div class="slider">
                    <div class="slide-track">
                        <div className='slide flex items-center gap-5'>
                            <a href="">
                                <img src="/images/link-1.png" alt="" />
                            </a>
                        </div>
                        <div className='slide flex items-center gap-5'>
                            <a href="">
                                <img src="/images/link-2.png" alt="" />
                            </a>
                        </div>
                        <div className='slide flex items-center gap-5'>
                            <a href="">
                                <img src="/images/link-3.png" alt="" />
                            </a>
                        </div>
                        <div className='slide flex items-center gap-5'>
                            <a href="">
                                <img src="/images/link-4.png" alt="" />
                            </a>
                        </div>
                        <div className='slide flex items-center gap-5'>
                            <a href="">
                                <img src="/images/link-5.png" alt="" />
                            </a>
                        </div>
                        <div className='slide flex items-center gap-5'>
                            <a href="">
                                <img src="/images/link-6.png" alt="" />
                            </a>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}
